import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleHalfStroke,
  faCircleCheck,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

interface DistributionStatusIconProps {
  pendingQuantity: number;
  requiredQuantity: number;
}

export const DistributionStatusIcon = (props: DistributionStatusIconProps) => {
  const statusIcon = (): IconDefinition => {
    if (props.pendingQuantity === props.requiredQuantity) {
      return faCircle;
    }
    if (props.pendingQuantity === 0) {
      return faCircleCheck;
    }
    if (props.pendingQuantity < 0) {
      return faCircleExclamation;
    }
    return faCircleHalfStroke;
  };

  const iconTint = (): string => {
    if (props.pendingQuantity === props.requiredQuantity) {
      return "text-info";
    }
    if (props.pendingQuantity === 0) {
      return "text-success";
    }
    if (props.pendingQuantity < 0) {
      return "text-warning";
    }
    return "text-info";
  };

  return <FontAwesomeIcon icon={statusIcon()} className={iconTint()} />;
};
